var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 22.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.286,19.688v1.758A1.063,1.063,0,0,1,13.214,22.5H1.071A1.063,1.063,0,0,1,0,21.445V5.273A1.063,1.063,0,0,1,1.071,4.219H4.286V17.227a2.483,2.483,0,0,0,2.5,2.461Zm0-15.117V0h-7.5A1.063,1.063,0,0,0,5.714,1.055V17.227a1.063,1.063,0,0,0,1.071,1.055H18.929A1.063,1.063,0,0,0,20,17.227V5.625H15.357A1.066,1.066,0,0,1,14.286,4.57Zm5.4-1.364L16.742.309A1.08,1.08,0,0,0,15.985,0h-.27V4.219H20V3.952a1.046,1.046,0,0,0-.314-.746Z",
    fill: "#91c499",
    "data-name": "Icon awesome-copy"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy1);
export default __webpack_public_path__ + "static/media/copy-1.eac3ab848e3a31cd64f18ee7a7f22f08.svg";
export { ForwardRef as ReactComponent };